import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import DataFilterBuilder from "./DataFilterBuilder";
import { MainRoutes } from "common/config/route.config";
import { snowflakeSchemas } from "../../data";

const DataFilterBuilderPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get parameters from URL
  const tableName = searchParams.get("table") || "default_table";
  const selectedColumnsParam = searchParams.get("columns") || "";
  const selectedColumns = selectedColumnsParam
    ? selectedColumnsParam.split(",")
    : [];

  // Find the schema for the table
  const schema = snowflakeSchemas.find((s) => s.tableName === tableName) || {
    tableName: tableName,
    columns: [],
    recordCount: 0
  };

  // Construct the back route with current parameters
  const backRoute = `${MainRoutes.AVAILABLE_DETAILS}?table=${tableName}&columns=${selectedColumnsParam}`;

  const handleContinue = (filters: any[]) => {
    // Navigate to mapping interface with current parameters and filters
    const filtersParam = encodeURIComponent(JSON.stringify(filters));
    navigate(
      `${MainRoutes.DATA_MAPPING_INTERFACE}?table=${tableName}&columns=${selectedColumnsParam}&filters=${filtersParam}`
    );
  };

  const handleBack = () => {
    // Navigate back to available tables with parameters
    navigate(
      `${MainRoutes.AVAILABLE_DETAILS}?table=${tableName}&columns=${selectedColumnsParam}`
    );
  };

  return (
    <DataFilterBuilder
      schema={schema}
      selectedColumns={selectedColumns}
      onContinue={handleContinue}
      onBack={handleBack}
      backRoute={backRoute}
    />
  );
};

export default DataFilterBuilderPage;
